// OsdExamInfo.js
export const examInfo = {
    title: "ÖSD B2 Vizsgaleírás",
    sections: [
        {
            icon: "📖",
            name: "Leseverstehen (90 perc)",
            desc: "Összesen 90 perc áll rendelkezésre a 4 feladat megoldásához. Max. 20 pont. (Minimum 10 pont kell a sikerhez)",
            details: [
                "1. feladat: Hosszabb szöveg, feleletválasztós kérdéssor (5 feladat).",
                "2. feladat: 10 cím hozzárendelése 5 rövid szöveghez.",
                "3. feladat: Lückentext (nyitott). Max 3 betűs szórészletek.",
                "4. feladat: Hiányos szöveg pótlása ragozással (grammatika)."
            ]
        },
        {
            icon: "🎧",
            name: "Hörverstehen (kb. 30 perc)",
            desc: "Max. 20 pont. (Minimum 10 pont kell a sikerhez)",
            details: [
                "1. feladat: Rádióműsor/interjú. 10 igaz/hamis állítás.",
                "2. feladat: Beszélgetés egy szituációról. Táblázat kitöltése adatokkal."
            ]
        },
        {
            icon: "✍️",
            name: "Schreiben (90 perc)",
            desc: "Két feladat, összesen 30 pont.",
            details: [
                "1. feladat: Panaszlevél írása (min. 120 szó).",
                "2. feladat: Véleménykifejtés (min. 120 szó)."
            ]
        },
        {
            icon: "🗣️",
            name: "Sprechen (15 perc felkészülés + 15 perc vizsga)",
            desc: "Max. 30 pont.",
            details: [
                "1. feladat: Ismerkedés és tanácsadás.",
                "2. feladat: Kép értelmezése és leírása.",
                "3. feladat: Saját vélemény kifejtése és vita."
            ]
        }
    ]
};